import { ClaimManagement } from 'pages/claims';
import { useTutorialClaimManagementData } from './useTutorialClaimManagementData';
import { QueryClient } from '@tanstack/react-query';
import { useTutorialStore } from 'store/tutorialStore';
import { TutorialComponent } from 'components/tutorial/TutorialComponent';
import { claimsSteps } from 'components/tutorial/Steps';

interface TutorialClaimManagementProps {
  queryClient: QueryClient;
}

export const TutorialClaimManagement: React.FC<
  TutorialClaimManagementProps
> = ({ queryClient }) => {
  const {
    claims,
    claimStatusesCount,
    providers,
    sites,
    status,
    invalidData,
    payors,
    remittances,
    isLoading,
    isError,
    isFetching,
    pagination,
    setPagination,
    errorMessage,
    refetchClaims,
    refetchStatusesCount,
  } = useTutorialClaimManagementData();

  const { isTutorialActive } = useTutorialStore();

  return (
    <>
      <ClaimManagement
        claims={claims}
        claimStatuses={claimStatusesCount}
        providers={providers}
        sites={sites}
        status={status}
        payors={payors}
        remittances={remittances}
        isLoading={isLoading}
        isError={isError}
        isFetching={isFetching}
        setPagination={setPagination}
        pagination={pagination}
        invalidData={invalidData}
        errorMessage={errorMessage}
        refetchClaims={refetchClaims}
        refetchStatusesCount={refetchStatusesCount}
        queryClient={queryClient}
      />
      {isTutorialActive && (
        <TutorialComponent steps={claimsSteps} page="claims" />
      )}
    </>
  );
};
